export class ApiError extends Error {
  status: number;
  payload: unknown;
  constructor(status: number, message: string, payload: unknown) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.payload = payload;
  }
}

export async function apiRequest<T>(input: RequestInfo | URL, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body && !headers.has('content-type')) headers.set('content-type', 'application/json');
  const response = await fetch(input, { ...init, headers, credentials: 'same-origin' });
  const contentType = response.headers.get('content-type') ?? '';
  const payload = contentType.includes('application/json') ? await response.json().catch(() => null) : await response.text().catch(() => '');
  if (!response.ok) {
    const message = (() => {
      if (payload && typeof payload === 'object') {
        const body = payload as { message?: unknown; error?: unknown };
        const detailed = typeof body.message === 'string' ? body.message.trim() : '';
        const fallback = typeof body.error === 'string' ? body.error.trim() : '';
        if (detailed) return detailed;
        if (fallback) return fallback;
      }
      return response.statusText || `Request failed (${response.status})`;
    })();
    if (response.status === 401 && typeof window !== 'undefined' && !window.location.pathname.startsWith('/login')) {
      const next = `${window.location.pathname}${window.location.search}`;
      window.location.assign(`/login/?next=${encodeURIComponent(next)}`);
    }
    throw new ApiError(response.status, message, payload);
  }
  return payload as T;
}

export const api = apiRequest;
